import CommunityRating from '@react/profile/v2/CommunityReviews/CommunityRating';
import AskAgentQuestionModalButton from '@react/shared/components/AskAgentQuestionModalButton/AskAgentQuestionModalButton';
import { NATIONAL_COORDINATOR_SLUGS } from '@sly/core/constants/agents';
import AgentProfile4Fields from 'sly/agentsAgentPage/AgentProfilePage/AgentProfilePageSummaryWrapper/AgentProfilePageSummary/AgentProfileText/AgentProfile4Fields';
import AgentProfileAskQuestion from 'sly/agentsAgentPage/AgentProfilePage/AgentProfilePageSummaryWrapper/AgentProfilePageSummary/AgentProfileText/AgentProfileAskQuestion';
import { ChatFill } from 'sly/icons';
import { Link } from 'sly/system';
import Heading from 'sly/system/Heading';
import { HeadingLevels } from 'sly/system/Heading/Heading.types';

export interface AgentProfileTextProps {
  displayName: string;
  ratingValue: number;
  numRatings: number;
  recentFamiliesHelped: number;
  operatingIn?: string;
  showAskQuestionButton: boolean;
  experience?: string;
  withSeniorlySince?: string;
  buttonHref: string;
  agentFirstName: string;
  heading?: string;
  onAskAgentQuestion?: () => void;
  agentUrl?: string;
  headingFont?: keyof typeof HeadingLevels;
  displayOperatingIn?: boolean;
  disableGoTo?: boolean;
  linkHref?: string;
  agentSlug?: string;
}

export default function AgentProfileText({
  displayName,
  ratingValue,
  numRatings,
  recentFamiliesHelped,
  operatingIn,
  showAskQuestionButton,
  experience,
  withSeniorlySince,
  buttonHref,
  agentFirstName,
  heading,
  onAskAgentQuestion,
  agentUrl,
  headingFont = 'font-t-xl',
  displayOperatingIn = true,
  disableGoTo = false,
  linkHref,
  agentSlug,
}: AgentProfileTextProps) {
  const updatedHeading =
    agentSlug && NATIONAL_COORDINATOR_SLUGS.includes(agentSlug)
      ? 'National Coordinator'
      : heading;

  return (
    <div
      className='my-0 flex flex-col md:flex-1'
      data-tp-id='gen-div-8f20f7ae-c254-4b4e-bb21-588db23c97a3'
    >
      <div
        className='mb-1 text-center lg:text-left'
        data-tp-id='gen-div-116101b3-a49b-47a6-935d-c9b6010714e9'
      >
        <span data-tp-id='gen-span-f60ab480-4a42-4f21-9beb-7d2b5c58ad0c'>
          {updatedHeading || 'Seniorly Local Advisor'}
        </span>
      </div>
      {agentUrl ? (
        <Link
          to={agentUrl}
          target='_blank'
          className='text-slate-base'
          rel='noreferrer'
        >
          <Heading font={headingFont} className='text-center lg:text-left'>
            {displayName}
          </Heading>
        </Link>
      ) : (
        <Heading
          as='h1'
          font={headingFont}
          className='text-center lg:text-left'
        >
          {displayName}
        </Heading>
      )}

      {ratingValue > 0 && (
        <div className='mx-auto mt-1 lg:mx-0'>
          <CommunityRating
            rating={ratingValue}
            numReviews={numRatings}
            reviewsText
            textClassName='font-b-s slate-lighter-40'
            goToReviews={
              // eslint-disable-next-line @typescript-eslint/no-empty-function
              disableGoTo ? undefined : () => {}
            }
            linkHref={linkHref}
          />
        </div>
      )}
      <AgentProfile4Fields
        familiesHelped={recentFamiliesHelped}
        yearsOfExperience={experience}
        operatingIn={operatingIn}
        withSeniorlySince={withSeniorlySince}
        displayOperatingIn={displayOperatingIn}
      />
      {showAskQuestionButton &&
        (buttonHref ? (
          <AgentProfileAskQuestion buttonHref={buttonHref} />
        ) : (
          <AskAgentQuestionModalButton
            className='w-full md:m-auto md:w-fit lg:m-0'
            buttonText={`Message ${agentFirstName}`}
            onSubmit={onAskAgentQuestion}
            agentSlug={agentSlug}
          >
            <ChatFill className='mr-[10px] text-white' />
            Message {agentFirstName}
          </AskAgentQuestionModalButton>
        ))}
    </div>
  );
}
